<template>
  <t-layout :showNav="false">
    <div class="page" v-if="showCountdown">
      <img
        src="https://wz-s1.makingdreams101.cn/wanzhuan_mp/h5/tool/link/countdown_bg.png"
        alt=""
        class="page_bg"
      />
      <div class="btn countdown">{{ countdown }}</div>
    </div>
    <div class="page" v-else>
      <img
        src="https://wz-s1.makingdreams101.cn/wanzhuan_mp/h5/tool/link/link_bg.png"
        alt=""
        class="page_bg"
      />
      <!-- <div class="btn link" @click="handleClick()"></div> -->
    </div>
  </t-layout>
</template>

<script>
export default {
  name: 'toolLinkView',
  data() {
    return {
      eventName: '美国运通卡礼遇',
      pageId: null,
      pageInfo: null,
      showCountdown: true,
      countdown: 3,
      timer: null
    }
  },
  created() {
    this.startCountdown()
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  methods: {
    startCountdown() {
      this.timer = setInterval(() => {
        this.countdown--
        //倒计时结束，隐藏蒙版，并跳转页面
        if (this.countdown <= 0) {
          clearInterval(this.timer)
          this.timer = null
          this.initPage()
          setTimeout(() => {
            this.showCountdown = false
          }, 200)
        }
      }, 1000)
    },
    initPage() {
      console.log('页面初始化')
      this.handleClick()
    },
    handleClick() {
      // const url =
      //   'weixin://dl/business/?appid=wx8a47e25ed2b817fd&path=pages/benefits/detail/index&query=homepageNo%3DBHP718484589844983808%26benefitNo%3DB718277192086032384%26utm_adScene%3D1%26utm_source%3D2319&env_version=release'

      const page_query = 'articleNo=ART523229596968914944&utm_adScene=1&utm_source=3192'
      const url = `weixin://dl/business/?appid=wx8a47e25ed2b817fd&path=pages/articleDetail/index&query=${encodeURIComponent(
        page_query
      )}&env_version=release`

      // const url = 'https://www.americanexpress.com.cn/'

      console.log('====url====', url)

      window.location.href = url
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  background: #5a86a2;
  width: 100%;
  min-height: 100vh;
  position: relative;
}

.page_bg {
  width: 100%;
  min-height: 100vh;
  display: block;
}

.btn {
  width: 100%;
  height: 38px;
  position: absolute;
  left: 0;
  top: 438px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  &.countdown {
    background-image: url('https://wz-s1.makingdreams101.cn/wanzhuan_mp/h5/tool/link/countdown_btn.png');
    line-height: 35px;
    letter-spacing: 0.5px;
    font-size: 21px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &.link {
    background-image: url('https://wz-s1.makingdreams101.cn/wanzhuan_mp/h5/tool/link/link_btn.png');
  }
}
</style>
